var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 5,
    viewBox: "0 0 16 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.4375C4 2.96793 3.78929 3.47664 3.41421 3.85171C3.03914 4.22679 2.53043 4.4375 2 4.4375C1.46957 4.4375 0.960859 4.22679 0.585786 3.85171C0.210714 3.47664 0 2.96793 0 2.4375C0 1.90707 0.210714 1.39836 0.585786 1.02329C0.960859 0.648214 1.46957 0.4375 2 0.4375C2.53043 0.4375 3.03914 0.648214 3.41421 1.02329C3.78929 1.39836 4 1.90707 4 2.4375ZM10 2.4375C10 2.96793 9.78929 3.47664 9.41421 3.85171C9.03914 4.22679 8.53043 4.4375 8 4.4375C7.46957 4.4375 6.96086 4.22679 6.58579 3.85171C6.21071 3.47664 6 2.96793 6 2.4375C6 1.90707 6.21071 1.39836 6.58579 1.02329C6.96086 0.648214 7.46957 0.4375 8 0.4375C8.53043 0.4375 9.03914 0.648214 9.41421 1.02329C9.78929 1.39836 10 1.90707 10 2.4375ZM14 4.4375C14.5304 4.4375 15.0391 4.22679 15.4142 3.85171C15.7893 3.47664 16 2.96793 16 2.4375C16 1.90707 15.7893 1.39836 15.4142 1.02329C15.0391 0.648214 14.5304 0.4375 14 0.4375C13.4696 0.4375 12.9609 0.648214 12.5858 1.02329C12.2107 1.39836 12 1.90707 12 2.4375C12 2.96793 12.2107 3.47664 12.5858 3.85171C12.9609 4.22679 13.4696 4.4375 14 4.4375Z",
    fill: "#868C9F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsIcon);
export default __webpack_public_path__ + "static/media/actionsIcon.a5241b92c4d160764db975f584d4de29.svg";
export { ForwardRef as ReactComponent };